window.addEventListener('load', function() {
  document.body.classList.add('loaded');
});

  setTimeout(() => {
    const scrollContainer = document.querySelector('.prod-sugg ul.product-grid');
    const scrollLeftBtn = document.getElementById('snap_prev');
    const scrollRightBtn = document.getElementById('snap_next');
    const scrollAmount = window.innerWidth < 768 ? 150 : 300;

    function updateButtonState() {
      if (scrollContainer.scrollLeft === 0) {
        scrollLeftBtn.classList.add('disabled');
      } else {
        scrollLeftBtn.classList.remove('disabled');
      }

      if (scrollContainer.scrollLeft + scrollContainer.clientWidth - 10 >= scrollContainer.scrollWidth) {
        scrollRightBtn.classList.add('disabled');
      } else {
        scrollRightBtn.classList.remove('disabled');
      }
    }

    if (scrollContainer && scrollLeftBtn && scrollRightBtn) {
      scrollLeftBtn.addEventListener('click', () => {
        scrollContainer.scrollLeft -= scrollAmount;
        updateButtonState();
      });

      scrollRightBtn.addEventListener('click', () => {
        scrollContainer.scrollLeft += scrollAmount;
        updateButtonState();
      });

      window.addEventListener('resize', () => {
        scrollAmount = window.innerWidth < 768 ? 150 : 300;
        updateButtonState();
      });

      updateButtonState();

      scrollContainer.addEventListener('scroll', updateButtonState);
    }
  }, 2000);
/////////////////////
//// Open Modal Box In Header Top Bar
let topbarItems = document.querySelectorAll('.topbar-item');
let openPopupAnchors = document.querySelectorAll('.open_popup');

function openModal(modalOverlay, modalBox) {
  modalOverlay.classList.add('active');
  modalBox.classList.add('active');
}

topbarItems.forEach(function (topbarItem) {
  let modalPopup = topbarItem.querySelector('.modal-popup');
  let modalOverlay = topbarItem.querySelector('.modalbox-overlay');
  let modalBox = topbarItem.querySelector('.modalbox');
  let closeModalButton = topbarItem.querySelector('.modal__close');
  let modalOVerlay = topbarItem.querySelector('.modalbox-overlay');

  if (modalPopup && modalOverlay && modalBox && closeModalButton) {
    modalPopup.addEventListener('click', function (event) {
      event.preventDefault();
      openModal(modalOverlay, modalBox);
    });

    closeModalButton.addEventListener('click', function () {
      modalOverlay.classList.remove('active');
      modalBox.classList.remove('active');
    });
    modalOVerlay.addEventListener('click', function () {
      modalOverlay.classList.remove('active');
      modalBox.classList.remove('active');
    });
  }
});

openPopupAnchors.forEach(function (openPopupAnchor) {
  openPopupAnchor.addEventListener('click', function (event) {
    event.preventDefault();
    // alert('test');
    let modalOverlay = document.querySelector('.modalbox-overlay');
    let modalBox = document.querySelector('.modalbox');
    openModal(modalOverlay, modalBox);
  });
});
/////////////////////

//// remove spaces in product description
const productDescription = document.querySelector(".product__info-wrapper .product_description");
// const collectiontDescription = document.querySelector(".collection-hero .collection-hero__description");

if (productDescription) {
  productDescription.innerHTML = productDescription.innerHTML.replace(/&nbsp;/g, ' ');
}
// if (collectiontDescription) {
//   collectiontDescription.innerHTML = collectiontDescription.innerHTML.replace(/&nbsp;/g, ' ');
// }

/////////////////////


////// Product Card Swatches Show/Hide
document.querySelectorAll('.number-showmore').forEach(function (anchor) {
  anchor.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default anchor behavior
    const fieldset = anchor.closest('fieldset');
    if (fieldset) { // Check if fieldset exists
      fieldset.classList.toggle('show_more');
    }
  });
});
/////////////////////


////// Product Card Swatchers
var productCards = document.querySelectorAll('.product-card-wrapper');

productCards.forEach(function (card) {
  // Get all the li elements inside the .variant-selects of the current card
  var variantItems = card.querySelectorAll('.variant-selects li');

  variantItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // Remove the 'selected' class from all li elements in the current card
      variantItems.forEach(function (variant) {
        variant.classList.remove('selected');
      });

      // Get the data-img attribute from the clicked li element
      var newImgUrl = item.getAttribute('data-img');
      item.classList.add('selected');  // Add the 'selected' class to the clicked item

      // Find the main image inside the same parent card
      var mainImage = card.querySelector('.card__media img');
      var pictureElement = card.querySelector('.card__media picture');
      var sourceElements = pictureElement ? pictureElement.querySelectorAll('source') : [];

      // Create and show the loader
      var loader = document.createElement('div');
      loader.className = 'image-loader'; // You can style this class in CSS
      card.querySelector('.card__media').appendChild(loader);

      // Update the image src
      var newImageSrc = '//thedressoutlet.com/cdn/shop/' + newImgUrl + '?width=364';
      var newImageSrcset = '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=165 165w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=360 360w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=533 533w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=720 720w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=940 940w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=1066 1066w,//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602 3008w';

      // Define new srcset values for the source elements
      var newSrcSets = {
        '(min-width: 1066px)': '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?&width=1066',
        '(min-width: 940px)': '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?&width=940',
        '(min-width: 720px)': '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?&width=720',
        '(min-width: 533px)': '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?&width=533',
        '(min-width: 360px)': '//www.thedressoutlet.com/cdn/shop/' + newImgUrl + '?&width=360'
      };

      // Preload the new image
      var img = new Image();
      img.src = newImageSrc;
      img.srcset = newImageSrcset;

      // When the image has loaded, replace the src of the main image and hide the loader
      img.onload = function () {
        mainImage.src = newImageSrc;
        mainImage.srcset = newImageSrcset;

        // Update each source element's srcset
        sourceElements.forEach(function (source) {
          var mediaSource = source.getAttribute('media');
          if (newSrcSets[mediaSource]) {
            source.srcset = newSrcSets[mediaSource];
          }
        });

        // Remove the loader
        loader.remove();
      };

      // Optionally handle image load errors
      img.onerror = function () {
     //   console.error('Image failed to load:', newImageSrc);
        loader.remove(); // Remove the loader even if the image fails to load
      };
    });
  });
});
/////////////////////


////// Changing Image and link for variants of new split products
document.addEventListener('click', function (e) {
  if (e.target.closest('.product-grid li .color-swatch_wrapper a')) {
    e.preventDefault();

    // Get the clicked anchor element
    var anchor = e.target.closest('a');

    // Get the parent product card (li element) of the clicked anchor
    var parentProductCard = anchor.closest('.product-grid li');

    // Remove the active class from all color swatches within the clicked product card
    var colorSwatchesInCard = parentProductCard.querySelectorAll('.color-swatch_wrapper a');
    colorSwatchesInCard.forEach(function (swatch) {
      swatch.classList.remove('ss-border-black');
    });

    // Add the active class to the clicked color swatch
    anchor.classList.add('ss-border-black');

    // Get the link and big image source
    var link = anchor.getAttribute('href');
    var imageBig = anchor.querySelector('img').getAttribute('data-src');

    // Get the slider slide wrapper
    var obj = anchor.closest('.grid__item, .product_item');

    // Update the main product image source in <img> inside <picture>
    var mainImage = obj.querySelector('.card__media img');
    if (mainImage) {
      // mainImage.setAttribute('src', imageBig);
      if (mainImage.hasAttribute('srcset')) {
        mainImage.setAttribute('src', imageBig);
        mainImage.setAttribute('srcset', imageBig);
      } else {
        mainImage.setAttribute('src', imageBig);
      }
    }

    // Update the <source> elements inside the <picture> tag with the new image
    var sources = obj.querySelectorAll('.card__media picture source');
    sources.forEach(function (source) {
      source.setAttribute('srcset', imageBig);  // Replace with the new image URL
    });

    // Update the href attribute of the clicked anchor
    //anchor.setAttribute('href', link);
    var infoLink = obj.querySelector('.card--media .card__inner + .card__content .card__information .card__heading  a');
    if (infoLink) {
      infoLink.setAttribute('href', link);
    }
  }
});
/////////////////////////


////// Google Map
// Function to load the iframe after a delay
    function loadMap() {
      var mapIframe = document.createElement('iframe');
      mapIframe.src = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6612.690410996136!2d-118.25663100000001!3d34.035015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2b953cee9fa5d%3A0x497f1cad35f1de06!2sTheDressOutlet.com!5e0!3m2!1sen!2sin!4v1721811817197!5m2!1sen!2sin";
      mapIframe.width = "100%";
      mapIframe.height = "400";
      mapIframe.style.border = "0";
      mapIframe.allowFullscreen = "";
      mapIframe.loading = "lazy";
      mapIframe.referrerPolicy = "no-referrer-when-downgrade";

      // Replace the placeholder with the map iframe
      var mapPlaceholder = document.getElementById('map-placeholder');
      mapPlaceholder.innerHTML = ""; // Clear the placeholder content
      mapPlaceholder.appendChild(mapIframe);
    }

    // Delay the map loading by 5 seconds (5000 milliseconds)
    setTimeout(loadMap, 5000);
////////////////////////

//// Show ADA Button when scrold down
document.addEventListener('scroll', function () {
  const element = document.querySelector('.uwy.userway_p5 .userway_buttons_wrapper');
  const scrollPosition = window.scrollY + window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;

  if (!element) return;
  const threshold = documentHeight * 0.85;

  if (scrollPosition >= threshold) {
      element.classList.add('active-now');
  } else {
      element.classList.remove('active-now');
  }
});
/*! lazysizes - v5.2.0 */
!function(a,b){var c=b(a,a.document,Date);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}("undefined"!=typeof window?window:{},function(a,b,c){"use strict";var d,e;if(function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};e=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in e||(e[b]=c[b])}(),!b||!b.getElementsByClassName)return{init:function(){},cfg:e,noSupport:!0};var f=b.documentElement,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h].bind(a),k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,c,e,f,g){var h=b.createEvent("Event");return e||(e={}),e.instance=d,h.initEvent(c,!f,!g),h.detail=e,a.dispatchEvent(h),h},w=function(b,c){var d;!g&&(d=a.picturefill||e.pf)?(c&&c.src&&!b[i]("srcset")&&b.setAttribute("srcset",c.src),d({reevaluate:!0,elements:[b]})):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<e.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,d=0,f=e.throttleDelay,g=e.ricTimeout,h=function(){b=!1,d=c.now(),a()},i=m&&g>49?function(){m(h,{timeout:g}),g!==e.ricTimeout&&(g=e.ricTimeout)}:A(function(){k(h)},!0);return function(a){var e;(a=!0===a)&&(g=33),b||(b=!0,e=f-(c.now()-d),e<0&&(e=0),a||e<9?i():k(i,e))}},C=function(a){var b,d,e=99,f=function(){b=null,a()},g=function(){var a=c.now()-d;a<e?k(g,e-a):(m||f)(f)};return function(){d=c.now(),b||(b=k(g,e))}},D=function(){var g,m,o,p,y,D,F,G,H,I,J,K,L=/^img$/i,M=/^iframe$/i,N="onscroll"in a&&!/(gle|ing)bot/.test(navigator.userAgent),O=0,P=0,Q=0,R=-1,S=function(a){Q--,(!a||Q<0||!a.target)&&(Q=0)},T=function(a){return null==K&&(K="hidden"==x(b.body,"visibility")),K||!("hidden"==x(a.parentNode,"visibility")&&"hidden"==x(a,"visibility"))},U=function(a,c){var d,e=a,g=T(a);for(G-=c,J+=c,H-=c,I+=c;g&&(e=e.offsetParent)&&e!=b.body&&e!=f;)(g=(x(e,"opacity")||1)>0)&&"visible"!=x(e,"overflow")&&(d=e.getBoundingClientRect(),g=I>d.left&&H<d.right&&J>d.top-1&&G<d.bottom+1);return g},V=function(){var a,c,h,j,k,l,n,o,q,r,s,t,u=d.elements;if((p=e.loadMode)&&Q<8&&(a=u.length)){for(c=0,R++;c<a;c++)if(u[c]&&!u[c]._lazyRace)if(!N||d.prematureUnveil&&d.prematureUnveil(u[c]))ba(u[c]);else if((o=u[c][i]("data-expand"))&&(l=1*o)||(l=P),r||(r=!e.expand||e.expand<1?f.clientHeight>500&&f.clientWidth>500?500:370:e.expand,d._defEx=r,s=r*e.expFactor,t=e.hFac,K=null,P<s&&Q<1&&R>2&&p>2&&!b.hidden?(P=s,R=0):P=p>1&&R>1&&Q<6?r:O),q!==l&&(D=innerWidth+l*t,F=innerHeight+l,n=-1*l,q=l),h=u[c].getBoundingClientRect(),(J=h.bottom)>=n&&(G=h.top)<=F&&(I=h.right)>=n*t&&(H=h.left)<=D&&(J||I||H||G)&&(e.loadHidden||T(u[c]))&&(m&&Q<3&&!o&&(p<3||R<4)||U(u[c],l))){if(ba(u[c]),k=!0,Q>9)break}else!k&&m&&!j&&Q<4&&R<4&&p>2&&(g[0]||e.preloadAfterLoad)&&(g[0]||!o&&(J||I||H||G||"auto"!=u[c][i](e.sizesAttr)))&&(j=g[0]||u[c]);j&&!k&&ba(j)}},W=B(V),X=function(a){var b=a.target;if(b._lazyCache)return void delete b._lazyCache;S(a),s(b,e.loadedClass),t(b,e.loadingClass),u(b,Z),v(b,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](e.srcsetAttr);(b=e.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,d,f){var g,h,j,l,m,p;(m=v(a,"lazybeforeunveil",b)).defaultPrevented||(d&&(c?s(a,e.autosizesClass):a.setAttribute("sizes",d)),h=a[i](e.srcsetAttr),g=a[i](e.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),m={target:a},s(a,e.loadingClass),p&&(clearTimeout(o),o=k(S,2500),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(M.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,e.lazyClass),z(function(){var b=a.complete&&a.naturalWidth>1;p&&!b||(b&&s(a,"ls-is-cached"),X(m),a._lazyCache=!0,k(function(){"_lazyCache"in a&&delete a._lazyCache},9)),"lazy"==a.loading&&Q--},!0)}),ba=function(a){if(!a._lazyRace){var b,c=L.test(a.nodeName),d=c&&(a[i](e.sizesAttr)||a[i]("sizes")),f="auto"==d;(!f&&m||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,e.errorClass)||!r(a,e.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,Q++,aa(a,b,f,d,c))}},ca=C(function(){e.loadMode=3,W()}),da=function(){3==e.loadMode&&(e.loadMode=2),ca()},ea=function(){if(!m){if(c.now()-y<999)return void k(ea,999);m=!0,e.loadMode=3,W(),j("scroll",da,!0)}};return{_:function(){y=c.now(),d.elements=b.getElementsByClassName(e.lazyClass),g=b.getElementsByClassName(e.lazyClass+" "+e.preloadClass),j("scroll",W,!0),j("resize",W,!0),j("pageshow",function(a){if(a.persisted){var c=b.querySelectorAll("."+e.loadingClass);c.length&&c.forEach&&l(function(){c.forEach(function(a){a.complete&&ba(a)})})}}),a.MutationObserver?new MutationObserver(W).observe(f,{childList:!0,subtree:!0,attributes:!0}):(f[h]("DOMNodeInserted",W,!0),f[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ea():(j("load",ea),b[h]("DOMContentLoaded",W),k(ea,2e4)),d.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba,_aLSL:da}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;f<g;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),d=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width)&&d!==a._lazysizesWidth&&c(a,f,e,d))},f=function(){var b,c=a.length;if(c)for(b=0;b<c;b++)d(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(e.autosizesClass),j("resize",g)},checkElems:g,updateElem:d}}(),F=function(){!F.i&&b.getElementsByClassName&&(F.i=!0,E._(),D._())};return k(function(){e.init&&F()}),d={cfg:e,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}});


(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if (typeof define == 'function' && define.amd) {
		define(['lazysizes'], factory);
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var bgLoad, regBgUrlEscape;
	var uniqueUrls = {};

	if(document.addEventListener){
		regBgUrlEscape = /\(|\)|\s|'/;

		bgLoad = function (url, cb){
			var img = document.createElement('img');
			img.onload = function(){
				img.onload = null;
				img.onerror = null;
				img = null;
				cb();
			};
			img.onerror = img.onload;

			img.src = url;

			if(img && img.complete && img.onload){
				img.onload();
			}
		};

		addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var tmp, load, bg, poster;
			if(!e.defaultPrevented) {

				var target = e.target;

				if(target.preload == 'none'){
					target.preload = target.getAttribute('data-preload') || 'auto';
				}

				if (target.getAttribute('data-autoplay') != null) {
					if (target.getAttribute('data-expand') && !target.autoplay) {
						try {
							target.play();
						} catch (er) {}
					} else {
						requestAnimationFrame(function () {
							target.setAttribute('data-expand', '-10');
							lazySizes.aC(target, lazySizes.cfg.lazyClass);
						});
					}
				}

				tmp = target.getAttribute('data-link');
				if(tmp){
					addStyleScript(tmp, true);
				}

				// handle data-script
				tmp = target.getAttribute('data-script');
				if(tmp){
					e.detail.firesLoad = true;
					load = function(){
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};
					addStyleScript(tmp, null, load);
				}

				// handle data-require
				tmp = target.getAttribute('data-require');
				if(tmp){
					if(lazySizes.cfg.requireJs){
						lazySizes.cfg.requireJs([tmp]);
					} else {
						addStyleScript(tmp);
					}
				}

				// handle data-bg
				bg = target.getAttribute('data-bg');
				if (bg) {
					e.detail.firesLoad = true;
					load = function(){
						target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};

					bgLoad(bg, load);
				}

				// handle data-poster
				poster = target.getAttribute('data-poster');
				if(poster){
					e.detail.firesLoad = true;
					load = function(){
						target.poster = poster;
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};

					bgLoad(poster, load);

				}
			}
		}, false);

	}

	function addStyleScript(src, style, cb){
		if(uniqueUrls[src]){
			return;
		}
		var elem = document.createElement(style ? 'link' : 'script');
		var insertElem = document.getElementsByTagName('script')[0];

		if(style){
			elem.rel = 'stylesheet';
			elem.href = src;
		} else {
			elem.onload = function(){
				elem.onerror = null;
				elem.onload = null;
				cb();
			};
			elem.onerror = elem.onload;

			elem.src = src;
		}
		uniqueUrls[src] = true;
		uniqueUrls[elem.src || elem.href] = true;
		insertElem.parentNode.insertBefore(elem, insertElem);
	}
}));
